import {texture} from "p3";
import common from "../common";
import PauseHelpPanel from "../ui/PauseHelpPanel";
import {iswebfont, resizeLabelToFitText} from "../utils";
import GameScene from "./GameScene";
import Scene from "./Scene";

export default class MenuScene extends Scene {
    /**
     * @param {string} sceneId
     */
    constructor(sceneId) {
        super(sceneId);

        this.buttonMargin = new PIXI.Rectangle(60, 40, 60, 50);
        this.buttonSpacing = 120;

        this._titleBanner = null;
        this._pauseHelpPanel = null;
    }

    createFill() {
        this._fill = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._fill.tint = 0x371937;
        this._fill.alpha = 0.7;
        this.addChild(this._fill);
    }

    /**
     * @param {number} x
     * @param {number} y
     * @return {P3.Button}
     */
    addCloseButton(x, y) {
        this._closeButton = P3.Button.create(
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_icon_cross"),
        );
        this._closeButton.x = x;
        this._closeButton.y = y;
        this.signalListeners.push(this._closeButton.signals.click.add(this._onCloseButtonClick, this));
        this.addChild(this._closeButton);

        return this._closeButton;
    }

    /**
     * @param {string} name
     */
    createTitleBanner(name) {
        this._titleBanner = new PIXI.Sprite(texture("title_bg"));
        this._titleBanner.anchor.set(0.5);
        this._titleBanner.x = common.STAGE_WIDTH/2;
        this._titleBanner.y = 100;
        this.addChild(this._titleBanner);

        if (!iswebfont()) {
            this._titleBanner.label = new PIXI.BitmapText(name.toUpperCase(), {
                fontName: "Alghera Pro",
                fontSize: 46,
                align: "center",
                tint: 0xFFFFFF
            });
        } else {
            this._titleBanner.label = new PIXI.Text(name.toUpperCase(), {
                fontFamily: "FredFredBurger",
                fontSize: 46,
                align: "center",
                fill: 0xFFFFFF
            });
        }
        this._titleBanner.label.position.set(0, !iswebfont() ? -13 : -18);
        this._titleBanner.label.anchor.set(0.5);
        this._titleBanner.addChild(this._titleBanner.label);

        resizeLabelToFitText(this._titleBanner.label, 300);
    }

    createPauseHelpPanel() {
        this._pauseHelpPanel = new PauseHelpPanel();
        this._pauseHelpPanel.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.7);
        this.addChild(this._pauseHelpPanel);

        this._animatePauseHelpPanelIn();
    }

    _animatePauseHelpPanelIn() {
        GameScene.active.addTween(gsap.to(this._pauseHelpPanel, 0.3, {
            y: common.STAGE_HEIGHT * 0.55,
            ease: Expo.easeOut
        }));
    }

    animateTitleBannerIn() {
        GameScene.active.addTween(gsap.to(this._titleBanner, 0.3, {
            y: this._titleBanner.y,
            ease: Expo.easeOut
        }));
        this._titleBanner.y = -300;
    }

    animateCloseButtonIn() {
        GameScene.active.addTween(gsap.to(this._closeButton.scale, 0.3, {
            x: 1,
            y: 1,
            ease: Back.easeOut,
            onComplete:() => {
                this._closeButton.interactive = true;
            }
        }));
    }

    animateTitleBannerOut() {
        GameScene.active.addTween(gsap.to(this._titleBanner, 0.3, {
            y: -300,
            ease: Expo.easeIn
        }));
    }

    animateFillOut() {
        GameScene.active.addTween(gsap.to(this._fill, 0.3, {
            alpha: 0
        }));
    }

    animateCloseButtonOut() {
        this._closeButton.interactive = false;
        GameScene.active.addTween(gsap.to(this._closeButton.scale, 0.3, {x:0, y:0, ease:Sine.easeIn}));
    }

    animateHide(){
        
    }

    /**
    * @private
    */
    _onCloseButtonClick() {
        this.animateHide(() => {
            this.signals.previous.dispatch();
        });
    }

    resize() {
        super.resize();

        if (this.isSceneLoaded) {
            this.resizeFill();
        }
    }

    resizeFill() {
        if (this._fill) {
            this._fill.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
            this._fill.width = P3.View.width;
            this._fill.height = P3.View.height;
        }
    }

    get helpPanel() {
        return this._pauseHelpPanel;
    }
}
